export class AccessRequest {
  constructor(
    public id?: number,
    public firstname?: string,
    public lastname?: string,
    public email?: string,
    public phone?: string,
    public company?: string,
    public notes?: string,
    public granted?: boolean,
    public denied?: boolean,
    public updatedOn?: Date,
    public updatedBy?: string
  ) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/models/access-request.ts